import { Link } from "react-router-dom";

import Proptypes from "prop-types";

import { Breadcrumb, BreadcrumbItem } from "reactstrap";

import { Home } from "react-feather";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";

const BreadCrumbs = (props) => {
    const { breadCrumbTitle, crumbs } = props;
    const { templates, items: contracts } = useSelector(
        (state) => state.contract
    );
    const { items: tokens } = useSelector((state) => state.token);
    const denide = {
        library: ["", "nft", "erc721", "erc721a", "erc721psi", "erc20", "erc1155", "all", "master-contract"],
        contracts: [""],
        administration: [
            "",
            "ERC721",
            "ERC721A",
            "ERC721PSI",
            "ERC20",
            "ERC1155",
            "master-upgrade",
            "master-new",
        ],
    };

    const allowedCrumbs = crumbs.filter(
        (item) => !denide[breadCrumbTitle.toLowerCase()].includes(item)
    );
    const newCrumbs = allowedCrumbs.map((item, index) => {
        const crumbLength = allowedCrumbs.length;
        let address;
        if (item === "copy") {
            address = { label: "Copy", link: "" };
        }
        if (item === "mint") {
            address = { label: "", link: "" };
        }
        if (item === "token") {
            address = { label: "", link: "" };
        }

        if (index > 0 && allowedCrumbs[index - 1] === "library") {
            address = {
                label: templates.find((i) => i._id === item)?.type,
                link:
                    index === crumbLength - 1
                        ? ""
                        : `/library/master-contract/${item}`,
            };
        }
        if (
            index > 0 &&
            typeof item === "string" &&
            (allowedCrumbs[index - 1] === "contracts" ||
                allowedCrumbs[index - 1] === "mint" ||
                allowedCrumbs[index - 1] === "copy" ||
                allowedCrumbs[index - 2] === "copy")
        ) {
            const contract = contracts.find((i) => i._id === item);
            const token = tokens.find((i) => i._id === item);

            address = contract
                ? {
                      label: contract?.customName ?? contract.type,
                      link:
                          index === crumbLength - 1 &&
                          allowedCrumbs[index - 1] === "mint"
                              ? `/contracts/${item}`
                              : allowedCrumbs[index - 2] === "mint" &&
                                allowedCrumbs[index - 1] === "copy"
                              ? `/contracts/${item}`
                              : "",
                  }
                : {
                      label: token?.type,
                      link:
                          index !== crumbLength - 1 ||
                          allowedCrumbs[index - 2] === "copy"
                              ? `/contracts/token/${item}`
                              : "",
                  };
        }
        if (
            index > 0 &&
            item === "token" &&
            allowedCrumbs[index - 1] === "contracts"
        ) {
            const token = tokens.find(
                (i) => i._id === allowedCrumbs[index + 1]
            );
            const contractID = token?.contractId;
            const contract = contracts.find((i) => i._id === contractID);
            address = {
                label: contract?.customName ?? contract.name,
                link:
                    index === crumbLength - 1 ? "" : `/contracts/${contractID}`,
            };
        }
        if (index > 0 && allowedCrumbs[index - 1] === "token") {
            const token = tokens.find((i) => i._id === item);
            address = {
                label: token?.name,
                link:
                    index === crumbLength - 1 ? "" : `/contracts/token/${item}`,
            };
        }
        if (index > 0 && allowedCrumbs[0] === "administration") {
            if (index === crumbLength - 1) {
                address = {
                    label:
                        allowedCrumbs[index - 1] === "contracts"
                            ? templates.find((i) => i._id === item)?.name
                            : item,
                    link: crumbs.includes("master-new")
                        ? `/administration/${item}`
                        : crumbs.includes("master-upgrade")
                        ? `/administration/contracts/${item}`
                        : "",
                };
            } else {
                address = {
                    label: item,
                    link: `/administration/${item}`,
                };
            }
        }
        return address ?? { label: item, link: `/${item}` };
    });
    if (crumbs.includes("master-upgrade")) {
        newCrumbs.push({ label: "Upgrade contract", link: "" });
    }
    if (crumbs.includes("mint")) {
        newCrumbs.push({
            label: crumbs.includes("copy") ? "Copy" : "Mint",
            link: "",
        });
    }
    if (crumbs.includes("master-new")) {
        newCrumbs.push({ label: "Deploy new master smart contract", link: "" });
    }

    return (
        <div className="content-header row">
            <div className="content-header-left col-md-9 col-12 mb-2">
                <div className="row breadcrumbs-top">
                    <div className="col-12 d-flex align-items-center">
                        {breadCrumbTitle ? (
                            <h2 className="content-header-title float-start mb-0">
                                {breadCrumbTitle}
                            </h2>
                        ) : (
                            ""
                        )}
                        <div className="breadcrumb-wrapper vs-breadcrumbs d-sm-block d-none col-12">
                            <Breadcrumb>
                                <BreadcrumbItem tag="li">
                                    <Link to="/">
                                        <Home />
                                    </Link>
                                </BreadcrumbItem>
                                {newCrumbs.map(
                                    (crumb, i) =>
                                        crumb.label && (
                                            <BreadcrumbItem
                                                key={crumb.label}
                                                tag="li"
                                                className="text-primary"
                                            >
                                                {crumb.link ? (
                                                    <Link
                                                        style={{
                                                            display:
                                                                "inline-block",
                                                            textTransform:
                                                                "capitalize",
                                                        }}
                                                        to={crumb.link}
                                                    >
                                                        {crumb.label}
                                                    </Link>
                                                ) : (
                                                    <Typography
                                                        component="span"
                                                        sx={{
                                                            textTransform:
                                                                "capitalize",
                                                            color: "#7367f0",
                                                            fontFamily:
                                                                "Montserrat",
                                                            fontSize: "1rem",
                                                            fontWeight: "400",
                                                            cursor: "default",
                                                        }}
                                                    >
                                                        {crumb.label}
                                                    </Typography>
                                                )}
                                            </BreadcrumbItem>
                                        )
                                )}
                            </Breadcrumb>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BreadCrumbs;

// ** PropTypes
BreadCrumbs.propTypes = {
    breadCrumbTitle: Proptypes.string.isRequired,
    breadCrumbActive: Proptypes.string,
};
